import { useTranslation } from 'react-i18next'
import styles from './index.module.less'
import classNames from 'classnames'
import { I_Block } from '@/api/blocks/interface'
import AddressHash from '@/components/AddressHash'
import { getFormatTimeZone, isEmptyOrNil } from '@/utils'
import { formatValue, ugagToGag, ugeaToGea2, ugeaToGea3 } from '@/utils/number'
import { useEffect, useState } from 'react'
import useMeNavigate from '@/hooks/useMeNavigate'
import { ValidatorNodeFormat } from '@/enums'
import { useGlobalStore } from '@/hoxStore/globalStore'
const CardInfo = ({ cardData }: { cardData: I_Block }) => {
  const navigate = useMeNavigate()
  const { t } = useTranslation()
  const { curReponsive } = useGlobalStore()
  const { timeUtc0 = '-', currentTime = '-' } = getFormatTimeZone(cardData.timestamp)
  const dealMoniker = (value: string) => {
    if (isEmptyOrNil(value)) return '-'
    const val = `${value}`!.replace(/-node$/, '')
    if (ValidatorNodeFormat[val.toLocaleUpperCase() as keyof typeof ValidatorNodeFormat]) {
      return t(ValidatorNodeFormat[val.toLocaleUpperCase() as keyof typeof ValidatorNodeFormat])
    }
    return val
  }

  const [rewardGag, setRewardGag] = useState<{
    value: string
    sigin: string
  }>({
    value: '-',
    sigin: '',
  })
  const [rewardGea, setRewardGea] = useState<{
    value: string
    sigin: string
  }>({
    value: '-',
    sigin: '',
  })

  const getGag = () => {
    const str = cardData.reward?.split(',')
    if (isEmptyOrNil(str)) return
    str.forEach((item) => {
      if (item.includes('ugag')) {
        setRewardGag(ugagToGag(item, false, 4))
      } else {
        setRewardGea(ugeaToGea2(item, false, 4))
      }
    })
  }
  useEffect(() => {
    getGag()
  }, [])

  return (
    <div className={styles.wrap}>
      <div
        className={styles.left}
        onClick={() => {
          navigate(`/blockchain/${cardData.height}`)
        }}
      >
        #{cardData.height}
      </div>
      <div className={styles.right}>
        <div className="right_1">
          <div className={styles.title}>hash</div>
          <div
            className={classNames({
              [styles.textStyleTwo]: true,
              font_14: true,
            })}
          >
            <AddressHash
              textStyle={{ color: '#000000' }}
              data={cardData.hash}
              cutOption
            ></AddressHash>
          </div>
        </div>
        {/* 提案节点 */}
        {/* <div className="right_2">
          <div className={styles.title}>{t('explorer_94')}</div>
          <div
            className={classNames({
              [styles.textStyleOne]: true,
              font_14: true,
            })}
          >
            {dealMoniker(cardData.validator_description.moniker)}
          </div>
        </div> */}
        <div className="right_2">
          {/* 交易数量 */}
          <div className={styles.title}>{t('explorer_90')}</div>
          <div
            className={classNames({
              [styles.textStyleOne]: true,
              font_14: true,
            })}
          >
            {formatValue(cardData?.num_txs)}
          </div>
        </div>
        <div className="right_3">
          <div className={styles.title}>GasFee</div>
          <div
            className={classNames({
              [styles.textStyleOne]: true,
              font_14: true,
            })}
          >
            {ugeaToGea2(cardData?.gas_fee).value}{' '}
            <span
              className={classNames({
                [styles.textStyleThree]: true,
                font_14: true,
              })}
            >
              {ugeaToGea2(cardData?.gas_fee).sigin}
            </span>
          </div>
        </div>
        <div className="right_4">
          {/* 区块奖励 */}
          <div className={styles.title}>{t('explorer_91')}</div>
          {cardData.reward ? (
            <>
              <div
                className={classNames({
                  [styles.textStyleOne]: true,
                  font_14: true,
                })}
              >
                {rewardGea.value}{' '}
                <span
                  className={classNames({
                    [styles.textStyleThree]: true,
                    font_14: true,
                  })}
                >
                  {rewardGea.sigin}
                </span>
              </div>
              <div
                style={{ marginTop: curReponsive?.size === 'mobile' ? '0px' : '4px' }}
                className={classNames({
                  [styles.textStyleOne]: true,
                  font_14: true,
                })}
              >
                {rewardGag.value}{' '}
                <span
                  className={classNames({
                    [styles.textStyleThree]: true,
                    font_14: true,
                  })}
                >
                  {rewardGag.sigin}
                </span>
              </div>
            </>
          ) : (
            '-'
          )}
        </div>
        <div className="right_5">
          {/* 时间戳 */}
          <div className={styles.title}>{t('explorer_92')}</div>
          <div
            className={classNames({
              [styles.textStyleOne]: true,
              grid_area_one: true,
              font_14: true,
            })}
          >
            <div
              className={classNames({
                [styles.textStyleOne]: true,
                font_14: true,
              })}
            >
              {timeUtc0}{' '}
              <span className={classNames(styles.textStyleThree, 'font_14')}>({'UTC+0'})</span>
            </div>
            <div
              style={{ marginTop: curReponsive?.size === 'mobile' ? '0px' : '4px' }}
              className={classNames({
                [styles.textStyleOne]: true,
                font_14: true,
              })}
            >
              {/* 当前时区 */}
              <span> {currentTime}</span>{' '}
              <span
                className={classNames({
                  [styles.textStyleThree]: true,
                  font_14: true,
                })}
              >
                ({t('explorer_95')})
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardInfo
